<template>
  <vue-final-modal
    name="video-modal"
    :value="isOpen"
    :classes="isMinimized ? ['video-modal-container', 'small-modal'] : ['video-modal-container', 'big-modal']"
    overlay-class="video-modal-overlay"
    :content-class="`video-modal-content bg-white border ${isMobile ? 'mobile-video' : ''}`"
    :lock-scroll="true"
    :hide-overlay="true"
    :click-to-close="false"
    :esc-to-close="false"
    :prevent-click="true"
    :attach="false"
    transition="vfm"
    overlay-transition="vfm"
    :z-index-auto="true"
    :z-index-base="1000"
    :z-index="false"
    :focus-retain="true"
    :focus-trap="false"
    :fit-parent="true"
    :drag="true"
    :resize="false"
    :min-width="310"
    :max-width="960"
    @opened="opened"
    @drag:start="dragStart"
    @drag:move="dragMove"
    @drag:end="dragEnd"
    @resize:start="resizeStart"
    @resize:move="resizeMove"
    @resize:end="resizeEnd"
  >
    <div class="video-modal-content--header d-flex align-items-center justify-content-between px-3">
      <div class="video-modal-content--title">
        <VideoIcon :size="isMinimized ? '1x' : '1.5x'" />
      </div>
      <div
        class="video-modal-content--controls d-flex align-items-center"
        :class="{
          'minimized': isMinimized
        }"
      >
        <Minimize2Icon v-if="!isMinimized" size="1.5x" @click="handleMinimize" />
        <Maximize2Icon v-else size="1x" @click="handleMinimize" />
        <XIcon @click="handleClose" size="1x" />
      </div>
    </div>
    <div
      ref="videoContentRef"
      class="video-modal-content--body"
    >
      <video-room-widget
        v-if="isOpen"
        v-bind="videoWidgetProps"
        :isMinimized="isMinimized"
        @onClose="handleClose"
      />
    </div>
  </vue-final-modal>
</template>

<script>
/* eslint-disable */
import { mapState, mapGetters } from "vuex";
import { EventBus } from "../events/eventBus";
import VideoRoomWidget from "./widgets/VideoRoomWidget";
import { VideoIcon, XIcon, Minimize2Icon, Maximize2Icon } from "vue-feather-icons";

export default {
  name: "AgencyVideoModalContainer",
  components: {
    VideoRoomWidget,
    VideoIcon,
    XIcon,
    Minimize2Icon,
    Maximize2Icon,
  },
  data() {
    return {
      isOpen: false,
      videoWidgetProps: null,
      hideModalOverlay: false,
      isMinimized: false,
      videoContentMaxHeight: 720,
    };
  },
  computed: {
    ...mapGetters("user", ["isMobile", "viewport"]),
  },
  created() {
    EventBus.$on("openVideoModal", (props) => {
      this.videoWidgetProps = props;
      this.isOpen = true;
      this.isMinimized = false;
    });
    EventBus.$on("closeVideoModal", () => {
      this.isOpen = false;
    });
  },
  methods: {
    opened() {
      this.handleResizeModal();
    },
    handleClose() {
      this.isOpen = false;
    },
    handleMinimize() {
      this.isMinimized = !this.isMinimized;
    },
    resizeStart(e) {
      this.handleResizeModal();
    },
    resizeMove(e) {
      this.handleResizeModal();
    },
    resizeEnd(e) {
      this.handleResizeModal();
    },
    dragStart(e) {
    },
    dragMove(e) {
    },
    dragEnd(e) {
    },
    handleResizeModal() {
      if (this.$refs.videoContentRef && this.$refs.videoContentRef.clientWidth) {
        this.videoContentMaxHeight = this.$refs.videoContentRef.clientWidth / 4 * 3;
      }
    }
  },
  watch: {    
    viewport: {
      handler(val) {
        this.handleResizeModal();
      },
      deep: true,
      immediate: true,
    },
    "$route.path": {
      handler(newRoute, oldRoute) {
        if (newRoute !== oldRoute && this.isOpen) {
          this.isOpen = false;
        }
      }
    }
  },
  beforeDestroy() {
    EventBus.$off("openVideoModal");
  },
};
</script>

<style lang="scss">
.video-modal-container {
  &.big-modal {
    .video-modal-content {
      width: min(960px, min(90vw, 90vh));
      border-radius: 5px;
      touch-action: none;
      position: relative;
      margin: unset;
      top: 1rem;
      left: 1rem;
      box-shadow: 1px 0px 3px rgba(0, 0, 0, 0.15);
      
      @supports (height: 100svh) {
        width: min(960px, min(90vw, 90svh));
      }

      &--header {
        width: 100%;
        height: 40px;
      }
      &--body {
        width: 100%;
        height: auto;
      }
      &--title {
        font-size: 1.5rem;
        font-weight: 500;
        color: #455a64;
      }
      &--controls {
        display: flex;
        align-items: center;
        gap: 12px;
      }

      &.mobile-video {
        width: max(310px, min(90vw, 90vh));
    
        @supports (height: 100svh) {
          width: max(310px, min(90vw, 90svh));
        }
      }
    }
  }

  &.small-modal {
    .video-modal-content {
      width: min(640px, min(90vw, 90vh));
      border-radius: 5px;
      touch-action: none;
      position: relative;
      margin: unset;
      top: 1rem;
      left: 1rem;
      box-shadow: 1px 0px 3px rgba(0, 0, 0, 0.15);
      
      @supports (height: 100svh) {
        width: min(640px, min(90vw, 90svh));
      }

      &--header {
        width: 100%;
        height: 30px;
      }

      &--body {
        width: 100%;
        height: auto;
      }

      &--title {
        font-size: 1.125rem;
        font-weight: 500;
        color: #455a64;
      }

      &--controls {
        display: flex;
        align-items: center;
        gap: 12px;
      }

      &.mobile-video {
        width: max(310px, min(90vw, 90vh));
    
        @supports (height: 100svh) {
          width: max(310px, min(90vw, 90svh));
        }
      }
    }
  }
}
</style>